module.exports = __webpack_public_path__ + "95fbee2cbacdac3fa4b0a5834ebf5105.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00009A96.png
// module id = 1699
// module chunks = 0